import React, { useContext } from 'react'
import AuthContext from '../../context/auth/authContext'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import lightbox2 from 'lightbox2'

function ProductSlider({ product, settings }) {
    const authContext = useContext(AuthContext);
    let { lp } = authContext;
    const $match = lp.products.find(x => x.id === product);
    let images = [];
    let lightbox = 0;
    if ($match) {
        images = $match.gallery;
        lightbox = $match.enable_lightbox
    }
    if (!settings) {
        settings = {
            dots: true,
            arow: false,
            infinite: true,
            autoplaySpeed: 5000,
            speed: 500,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        };
    }
    if (images.length) {
        return (
            <Slider {...settings}>

                {images.map((img, i) => {
                    return (lightbox == 1 ?
                        <a href={img} data-lightbox={`product_${$match.id}`} data-title={$match.name} key={i} className="slider-img-wrap" ><div className="slider-img" style={{ backgroundImage: `url("${img}")` }}></div>
                        </a>
                        :
                        <div key={i} className="slider-img-wrap" ><div className="slider-img" style={{ backgroundImage: `url("${img}")` }}></div>
                        </div>
                    )

                })}


            </Slider >
        )
    } return '';
}
export default ProductSlider
